
function quick() {
  document.querySelectorAll('.quick-view').forEach(el => {
    el.addEventListener('click', function () {
      const handle = this.dataset.handle;
      if (!handle) return;

      fetch(`/products/${handle}.js`)
        .then(res => res.ok ? res.json() : Promise.reject(res.status))
        .then(product => {
          const variant = product.variants[0]; // First variant
          const quantity = 1;

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variant.id, quantity: quantity })
          });
        })
        .then(res => res.ok ? res.json() : Promise.reject(res.status))
.then(() => fetch('/cart.js'))
.then(res => res.ok ? res.json() : Promise.reject(res.status))
.then(cart => {
  renderCartItems(cart); // ⬅️ Your function to update the cart UI
  location.reload(); // ✅ Page reload after updating cart
})
.catch(err => {
  console.error('Error:', err);
  alert('Something went wrong.');
});

    });
  });
}

function renderCartItems(cart) {
  const cartContainer = document.getElementById('cartItemsHolder');
  cartContainer.innerHTML = '';

  cart.items.forEach((item, index) => {
    const itemHTML = `
<div class="cart__item cart__item--no-border" data-item="${item.id}" data-item-index="${index + 1}" data-item-title="${item.product_title} / ${item.variant_title}">
  <div class="cart__item__image">
    <a href="${item.url}">
      <figure class="lazy-image lazy-image--cover">
        <img src="${item.image}" alt="${item.product_title} / ${item.variant_title}" width="200" height="300" loading="lazy" class="img-object-cover">
      </figure>
    </a>
  </div>

  <div class="cart__item__content">
    <div class="cart__item__content-inner">
      <div class="cart__item__info">
        <p class="cart__item__title">
          <a href="${item.url}">${item.product_title}</a>
        </p>
        <div class="cart__item__meta">
          ${item.options_with_values.map(opt => `
            <p class="cart__item__selected-options">
              <span>${opt.name}:</span>
              <span>${opt.value}</span>
            </p>
          `).join('')}
        </div>
      </div>

      <p class="cart__item__price"><ins>Rs.${(item.final_line_price / 100).toLocaleString()}</ins></p>
    </div>

    <div class="cart__item__bottom">
      <div class="cart__item__quantity" data-quantity-holder>
        <button type="button" class="cart__item__quantity-minus" data-quantity-minus title="Decrease Quantity - ${item.product_title}">
          <svg aria-hidden="true" class="icon icon-toggle-minus" viewBox="0 0 192 192">
            <path d="M30 96h132" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </button>
        <input type="number" name="updates[]" class="cart__item__quantity-field" data-id="${item.key}" value="${item.quantity}" title="Quantity - ${item.product_title}">
        <button type="button" class="cart__item__quantity-plus" data-quantity-plus title="Increase Quantity - ${item.product_title}">
          <svg aria-hidden="true" class="icon icon-toggle-plus" viewBox="0 0 192 192">
            <path d="M30 96h132M96 30v132" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </button>
      </div>

      <a href="#" class="cart__item__remove" data-id="${item.key}" title="Remove">
        <span>Remove</span>
      </a>
    </div>
  </div>
</div>`;
    cartContainer.insertAdjacentHTML('beforeend', itemHTML);
  });

  attachCartEvents(); // ✅ Rebind events for new items
}

// ✅ Common update function for quantity and remove
function updateCartItem(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
    .then(res => res.json())
    .then(cart => renderCartItems(cart))
    .catch(err => {
      console.error('Cart update failed:', err);
    });
}

// ✅ Bind +, - and remove events
function attachCartEvents() {
  document.querySelectorAll('.cart__item__quantity-plus').forEach(btn => {
    btn.addEventListener('click', function () {
      const input = this.closest('.cart__item__quantity').querySelector('.cart__item__quantity-field');
      const itemKey = input.dataset.id;
      const newQty = parseInt(input.value) + 1;
      updateCartItem(itemKey, newQty);
    });
  });

  document.querySelectorAll('.cart__item__quantity-minus').forEach(btn => {
    btn.addEventListener('click', function () {
      const input = this.closest('.cart__item__quantity').querySelector('.cart__item__quantity-field');
      const itemKey = input.dataset.id;
      const currentQty = parseInt(input.value);
      const newQty = Math.max(1, currentQty - 1);
      updateCartItem(itemKey, newQty);
    });
  });

  document.querySelectorAll('.cart__item__remove').forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const itemKey = this.dataset.id;
      updateCartItem(itemKey, 0);
    });
  });
}

document.addEventListener('DOMContentLoaded', quick);

